
var toggleCollapse = {
	data: {
		toggleConfig: {},
		timer: {}
	},
	mounted: function() {
		var children, minItems, initialHeight, panelRef, $panel, isTable, $btnTable;
		for (var key in this.$refs) {
			if (this.$refs.hasOwnProperty(key) && key.indexOf('-toggle') != -1) {
				initialHeight = null;
				panelRef = key.replace('-toggle', '');
				$panel = this.$refs[panelRef];
				this.$refs[key].setAttribute('data-target', panelRef);
				if ($panel.hasAttribute('data-min-items')) {
					children = $panel.children;
					isTable = children[0].tagName == 'TABLE';
					if (isTable) {
						children = children[0].firstChild.children;
					}
					minItems = parseInt($panel.getAttribute('data-min-items'));
					if (children.length > minItems) {
						initialHeight = children[minItems].offsetTop + (isTable ? 1 : 0);
						$panel.style.height = initialHeight + 'px';
					} else {
						this.$refs[key].classList.add('hidden');
						if (isTable) {
							$btnTable = $d.parents(this.$refs[key], 'table');
							if ($btnTable) $btnTable.classList.add('hidden');
						}
						$panel.style.height = 'auto';
					}
				}
				if (!this.toggleConfig[panelRef]) this.initializeToggle(panelRef, initialHeight);
			}
		}
	},
	methods: {
		toggleCollapse: function(event, config) {
			// this.toggleCollapse(null, { expand: true, target: 'property-type'});
			// @return (bool) isCollapsed
			if (event && event.target.tagName == 'A') event.preventDefault();
			config = config || {};
			var target = config.target ? config.target : event.target.getAttribute('data-target');

			if (!target || !this.$refs[target]) return;
			var toggleConfig = this.toggleConfig[target] || this.initializeToggle(target); 
	
			if (this.timer[target]) {
				win.clearTimeout(this.timer[target]);
			}
			var expand = config.expand != undefined ? config.expand : toggleConfig.isCollapsed;
	
			if (expand == toggleConfig.isCollapsed) {
				if (expand) {
					toggleConfig.$panel.style.height = toggleConfig.$panel.scrollHeight + 'px';
					toggleConfig.$panel.classList.remove('collapsed');
					toggleConfig.$btn.classList.add('is-expanded');

					if (toggleConfig.hasAltBtn) {
						toggleConfig.$btn.textContent = toggleConfig.altBtnTxt;
					}

					this.timer[target] = win.setTimeout(function(caller) { return function() {
						if (!caller.toggleConfig[target].isCollapsed) {
							toggleConfig.$panel.style.height = 'auto';
						}
					};}(this), 410);
				} else {

					toggleConfig.$panel.style.height = toggleConfig.$panel.scrollHeight + 'px';
					window.setTimeout(function() {
						toggleConfig.$panel.style.height = toggleConfig.initialHeight + 'px';
					}, 10);
					toggleConfig.$panel.classList.add('collapsed');
					toggleConfig.$btn.classList.remove('is-expanded');

					if (toggleConfig.hasAltBtn) {
						toggleConfig.$btn.textContent = toggleConfig.defaultBtnTxt;
					}
				}
				this.toggleConfig[target].isCollapsed = !expand;
			}
			return this.toggleConfig[target].isCollapsed;
		},
		initializeToggle: function(target, initialHeight) {
			var $btn = this.$refs[target+'-toggle'];
			var $panel = this.$refs[target];
			if (debug && !$panel) console.log('Reference '+target+' missing.'); 
			if (debug && !$btn) console.log('Reference '+target+'-toggle missing.'); 
			if ($btn.length) $btn = $btn[0];
			if ($panel.length) $panel = $panel[0];

			var isCollapsed = $panel.classList.contains('collapsed');
			var hasAltBtn = $btn.hasAttribute('data-alt-btn');
			initialHeight = initialHeight || 0;
			if (isCollapsed && !initialHeight) {
				initialHeight = $panel.getBoundingClientRect().height;
			}

			this.toggleConfig[target] = {
				$panel: $panel,
				$btn: $btn,
				isCollapsed: isCollapsed,
				initialHeight: initialHeight,
				hasAltBtn: hasAltBtn
			};
			if (hasAltBtn) {
				this.toggleConfig[target].defaultBtnTxt = $btn.textContent;
				this.toggleConfig[target].altBtnTxt = $btn.getAttribute( 'data-alt-btn');
			}
			this.$nextTick(function() {
				$panel.classList.add('animate');
			});
			return this.toggleConfig[target];
		}
	}
};
